import * as React from 'react';
import { useEffect, useState } from 'react';

import { ButtonGroup, Dialog, Typography2 } from '@coursera/cds-core';
import type { DialogContentProps, DialogProps } from '@coursera/cds-core';

import _t from 'i18n!nls/cds-labs';

const { HeadingGroup, Content, Actions } = Dialog;

type OwnProps = {
  acceptLabel?: string;
  cancelLabel?: string;
  headerLabel?: string;
  onAccept: () => void;
  onCancel: () => void;
  children?: DialogContentProps['children'];
};

export type Props = OwnProps & Omit<DialogProps, keyof OwnProps>;

const ConfirmModal = ({
  open,
  acceptLabel = _t('Confirm'),
  cancelLabel = _t('Cancel'),
  headerLabel = _t('Confirm changes'),
  onCancel,
  onAccept,
  children,
  ...props
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleAccept = () => {
    setIsLoading(true);
    onAccept();
  };

  useEffect(() => {
    if (!open) {
      setIsLoading(false);
    }
  }, [open]);

  return (
    <Dialog open={open} {...props} onClose={onCancel}>
      <HeadingGroup>{headerLabel}</HeadingGroup>
      <Content>
        <Typography2 component="div">{children}</Typography2>
      </Content>
      <Actions>
        <ButtonGroup
          size="medium"
          primaryButtonProps={{
            onClick: handleAccept,
            children: acceptLabel,
            loading: isLoading,
          }}
          alternateButtonProps={{
            variant: 'secondary',
            onClick: onCancel,
            children: cancelLabel,
          }}
        />
      </Actions>
    </Dialog>
  );
};

export default ConfirmModal;
